import Vue from 'vue'
import Vuetify, { VSnackbar, VBtn, VIcon, VDataFooter } from 'vuetify/lib'
import ru from 'vuetify/es5/locale/ru'

VDataFooter.extendOptions.props.itemsPerPageOptions.default = () => ([10, 25, 50]);

Vue.use(Vuetify, {
	components: {
		VSnackbar,
		VBtn,
		VIcon,
	},
})

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#4caf50',
				secondary: '#4caf50',
				tertiary: '#495057',
				accent: '#82B1FF',
				error: '#f55a4e',
				info: '#00d3ee',
				success: '#5cb860',
				warning: '#ffa21a',
			},
		},
	},
	breakpoint: {
		thresholds: {
			xs: 500,
			sm: 800,
			md: 1380,
			lg: 1600,
		},
	},
	icons: {
		iconfont: 'mdi',
	},
	lang: {
		locales: { ru },
		current: 'ru',
		defaultLocale: 'ru',
	},
})
